import mapCustomerInformationFields from "../../../lib/mapCustomerInformationFields";
import { loadCountryRestrictions } from "../loadCountryRestrictions/loadCountryRestrictions";
import { goToRoute } from "../goToRoute/goToRoute";
import {
  getTLDsFromCart,
  getAddonProductsInCart,
  isDomainPresent,
  hasVPSInCart,
} from "../../selectors";

const legalEntitiesFields = [
  "fiForeignerBirthDate",
  "firstName",
  "lastName",
  "type",
  "country",
  "company",
  "email",
  "address1",
  "zip",
  "city",
  "stateOrProvince",
  "mobileCode",
  "mobile",
  "vatNo",
];

export const loadFieldsForLoggedInCustomer = (
  isRegistranValue,
  legalEntityData,
) => {
  return async (dispatch, getState, { api }) => {
    let tlds = getTLDsFromCart(getState()).join(", ");
    const addonProducts = getAddonProductsInCart(getState());
    const isDomain = isDomainPresent(getState());
    const hasVPS = hasVPSInCart(getState());

    if (!isDomain && !hasVPS) {
      dispatch(goToRoute({ pageName: "domainSearch" }));
    }

    const type =
      (legalEntityData["type"] && legalEntityData["type"].value) ||
      legalEntityData.type;
    const country =
      (legalEntityData["country"] && legalEntityData["country"].value) ||
      legalEntityData.country;

    const citizenship =
      (legalEntityData["citizenship"] &&
        legalEntityData["citizenship"].value) ||
      legalEntityData.citizenship ||
      null;

    const exchangeProducts = [
      "EXCHANGE_ONLINE",
      "EXCHANGE_M365_BUSINESS_BASIC",
      "EXCHANGE_M365_BUSINESS_STANDARD",
    ];

    const isExchangeAmongAddons = addonProducts.some(({ name }) =>
      exchangeProducts.includes(name),
    );

    if (isExchangeAmongAddons) {
      // Check if Exchange is restricterd
      await dispatch(loadCountryRestrictions(country));
    }

    return api
      .getCustomerInformationFields(
        type.toUpperCase(),
        country,
        tlds,
        isRegistranValue,
        citizenship,
        true,
      )
      .then(
        (data) => {
          if (data.result.relevantFields.length > 0) {
            const allFields = mapCustomerInformationFields(
              data.result.relevantFields,
            );

            const fieldsForMissingValues = allFields.filter((field) => {
              // Show the rest required fields, which are not necessarily empty,
              // but are not included in the basic legal entity data
              const showExtraRequiredFields = !legalEntitiesFields.includes(
                field.name,
              );

              const valueOfLegalEntity =
                legalEntityData[field.name] &&
                typeof legalEntityData[field.name] === "object"
                  ? legalEntityData[field.name].value
                  : legalEntityData[field.name];

              return !valueOfLegalEntity || showExtraRequiredFields;
            });

            return {
              wasSuccessful: true,
              fieldsForMissingValues,
              allFields,
            };
          }

          return {
            wasSuccessful: false,
          };
        },
        (err) => {
          return { wasSuccessful: false };
        },
      );
  };
};
